export default {
  data() {
    return {
      selectionTables: [],
    }
  },
  mounted(){
    bus.$on('unselectedAllTables', () => {
      let selectionTables = this.selectionTables;
      this.selectionTables = [];
      selectionTables.map(o => {
        this.handleDataTable(this.tables[o])
      })
      this.setToStore();
    })
  },
  methods: {
    setToStore(){
      this.$store.commit('map/setSelectionTables', this.selectionTables)
      this.$store.commit('map/setAvailableForReservation',this.getTablesAvailableForReservation())
      this.$store.commit('map/setTablesOfCurrentReservation',this.getTablesOfCurrentReservation())
      this.$store.commit('map/setTablesWhereHasReservations',this.getTablesWhereHasReservations())
      this.$store.commit('map/setTablesOfNearestReservation',this.getTablesNearReservations())
    },
    addSelectionTables(table) {
      this.selectionTables.push(table.id)
      this.setToStore()
    },
    unSelectionTable(table) {
      this.selectionTables.splice(this.selectionTables.indexOf(parseInt(table.id)), 1);
      this.setToStore()
    }
  }
}
